/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./language-menu.vue?vue&type=template&id=f4891452&scoped=true&"
import script from "./language-menu.vue?vue&type=script&lang=js&"
export * from "./language-menu.vue?vue&type=script&lang=js&"
import style0 from "./language-menu.vue?vue&type=style&index=0&id=f4891452&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4891452",
  null
  
)

export default component.exports